import { computed } from 'mobx';

export default class QCTypeModel {
  id;
  store;

  constructor(store, qcType) {
    this.store = store;
    this.id = +qcType.id;
    this.caption = qcType.caption;
    this.description = qcType.description;
    this.color = qcType.color;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      caption: this.caption,
      description: this.description,
      color: this.color,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.caption = json.caption;
    this.description = json.description;
    this.color = json.color;
  }
}



// WEBPACK FOOTER //
// ./src/models/QCFlagModel.js